import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "./lib/api";
import { useAuth } from "./auth";

let processed = false;

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (processed) return;
    processed = true;
    const hash = location.hash || window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { navigate("/"); return; }
    const session_id = m[1];
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    api.post("/auth/session", { session_id })
      .then(r => {
        setUser(r.data.user);
        try { if (r.data.session_token) localStorage.setItem("oxy_token", r.data.session_token); } catch {}
        // Prefer explicit return path (e.g. from Create Now flow)
        let returnTo = "/dashboard";
        try {
          const stored = sessionStorage.getItem("oxy_return_to");
          if (stored) { returnTo = stored; sessionStorage.removeItem("oxy_return_to"); }
          const pendingType = sessionStorage.getItem("oxy_pending_type");
          if (pendingType) { returnTo = `/websites/new?type=${pendingType}`; sessionStorage.removeItem("oxy_pending_type"); }
        } catch {}
        window.history.replaceState({}, "", returnTo);
        navigate(returnTo, { replace: true, state: { user: r.data.user } });
      })
      .catch(() => navigate("/"));
  }, [location, navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-orange-500 border-t-transparent rounded-full animate-spin mx-auto" />
        <p className="mt-6 text-slate-600 font-medium">Signing you in…</p>
      </div>
    </div>
  );
}
